import { useEffect, useMemo } from 'react';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import {
  DEFAULT_APPROBATIONS_CONFIG,
  normalizeApprobationsConfig,
} from './approbationsConfigDefaults';

let hydratePromise = null;

function isApprobationsConfigHydrated(block) {
  return block?._syncedFromApi === true;
}

function hydrateApprobationsConfig(patchSettings) {
  if (!hydratePromise) {
    hydratePromise = localApiAdapter
      .get('/api/approbations/config')
      .then((response) => {
        const raw = response?.data !== undefined ? response.data : response;
        syncApprobationsConfigToSettings(raw || {}, patchSettings);
        return normalizeApprobationsConfig(raw || {});
      })
      .catch(() => DEFAULT_APPROBATIONS_CONFIG)
      .finally(() => {
        hydratePromise = null;
      });
  }
  return hydratePromise;
}

export function syncApprobationsConfigToSettings(config, patchSettings) {
  const normalized = normalizeApprobationsConfig(config);
  patchSettings({ approbations: { ...normalized, _syncedFromApi: true } }, { persist: false });
  return normalized;
}

/** Live approbations module config — synced from API once, then from SettingsContext. */
export function useApprobationsConfig() {
  const { settings, patchSettings } = useSettings();

  useEffect(() => {
    if (isApprobationsConfigHydrated(settings?.approbations)) return;
    void hydrateApprobationsConfig(patchSettings);
  }, [settings?.approbations, patchSettings]);

  return useMemo(
    () => normalizeApprobationsConfig(settings?.approbations || {}),
    [settings?.approbations],
  );
}
